import React, {useEffect} from "react";
import {useSubscription} from "../../subscription/useSubscription";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import IdeaDetailsModal from "../../idea/modal/IdeaDetailsModal";
import AllClients from "./allPortfolios/AllClients";
import ideaActionsFactory from "../../idea/ideaActions";
import {authorBackgroundColour} from "../../../style/styleConsts";
import authorActionsFactory from "./authorActions";
import {log} from "../../../logging/logEvent";
import {checkAuthorHomepageForClose} from "./checkAuthorHomepageForClose";
import OpenIdeasTable from "./openIdeas/OpenIdeasTable";
import {CentredLoader} from "../../elements/Loader";
import AuthorActivity from "./activity/AuthorActivity";

const Page = styled.div`
    display: flex;
    flex-grow: 1;
    min-height: 400px;
    min-width: 1100px;
    
    background-color: ${authorBackgroundColour};
    padding-left: 18px;
    padding-right: 18px;
    overflow-x: hidden;
    
    @media (max-device-width: 420px) {
        flex-grow: 0;
        flex-wrap: wrap;
        min-width: unset;
    }
    @media (max-width: 1200px) {
        flex-wrap: wrap;
        min-height: unset;
        min-width: unset;
    }
`;

const OpenIdeasContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 500px;
    padding-right: 18px;
    margin-top: 12px;
    margin-bottom: 12px;
    
    @media (max-device-width: 420px) {
        max-height: 400px;
        margin-bottom: 3px;
    }
    @media (max-width: 1200px) {
        max-height: 404px;
        flex-basis: 700px;
        margin-bottom: 3px;
    }
`;

const AllClientsContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 380px;
    margin-top: 12px;
    margin-bottom: 12px;
    
    @media (max-device-width: 420px) {
        max-height: 400px;
        margin-top: 3px;
    }
    @media (max-width: 1200px) {
        max-height: 300px;
        margin-top: 3px;
    }
`;

const ActivityContainer = styled.div`
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;    
    margin-left: 18px;
    margin-top: 12px;
    margin-bottom: 12px;
    
    @media (max-device-width: 420px) {
        max-height: 400px;
        margin-top: 3px;
    }
    @media (max-width: 1200px) {
        max-height: 300px;
        margin-top: 3px;
    }
`;

const AuthorHomepage = ({imeUserId}) => {
    useSubscription("OPEN_IDEAS_PERFORMANCE", `/TradeIdeasMonitor/ui/api/openIdeas/performance/${imeUserId}`, 60 * 60);
    useSubscription("AUTHOR_HOMEPAGE", `/ui/api/authorHomepage/${imeUserId}`, 60);
    const { authorDetails, userIdentity } = useSelector(({ authorDetails, userIdentity }) => ({ authorDetails, userIdentity }));
    const dispatch = useDispatch();
    useEffect(() => {
        log("PageComponentMounted", {page: "AuthorHomepage"});
        return () => {
        };
    }, []);

    if (!(authorDetails && authorDetails.content)) {
        return <div style={{padding: 20}}><CentredLoader/></div>;
    }

    const ideaActions = ideaActionsFactory(dispatch);
    const authorActions = authorActionsFactory(dispatch);

    return (
        <Page className="t-author-homepage">
            <OpenIdeasContainer>
                <OpenIdeasTable openIdeas={authorDetails.content.openIdeas}
                                editingIdeaId={authorDetails.editingIdeaId}
                                selectedIdeaAction={authorDetails.selectedIdeaAction}
                                authorActions={authorActions}
                                sort={authorDetails.openIdeasSort}
                                ideaActions={ideaActions}
                                ideaManagementBlocked={userIdentity.ideaManagementBlocked}
                                commentLengthLimit={userIdentity.commentLengthLimit}/>
            </OpenIdeasContainer>
            <AllClientsContainer>
                <AllClients userIdentity={userIdentity}
                            authorActions={authorActions}
                            sort={authorDetails.portfolioSort}
                            allPortfolios={authorDetails.content.allPortfolios}/>
            </AllClientsContainer>
            <ActivityContainer>
                <AuthorActivity activity={authorDetails.content.activity} ideaActions={ideaActions}/>
            </ActivityContainer>
            <IdeaDetailsModal checkIdeaClosed={checkAuthorHomepageForClose}/>
        </Page>
    );
};

const RequireUserIdentity = () => {
    const imeUserId = useSelector(state => state.userIdentity.imeUserId);
    if (!imeUserId) {
        return <div style={{padding: 20}}><CentredLoader/></div>;
    }

    return <AuthorHomepage imeUserId={imeUserId}/>;
};

export default RequireUserIdentity;
